export const url = process.env.REACT_APP_ENV === "prod"
    ? "https://backend.stravaporuch.ua"
    : process.env.REACT_APP_ENV === "test"
        ? "https://test-backend.stravaporuch.ua"
        : "https://fdct.mxuser.com"; // dev або за замовчуванням

export const url1 = process.env.REACT_APP_ENV === "prod"
    ? "https://backend.stravaporuch.ua"
    : process.env.REACT_APP_ENV === "test"
        ? "https://test-backend.stravaporuch.ua"
        : "https://fdct.mxuser.com";